// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: left;
  width: 610px;
  background-color: white;
  font-family: "Arial Bold", "Arial";
  max-width: 680px;
  margin: 0 auto;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@media screen and (max-width: 580px) {
  .App {
    width: 98%;
  }
}

@media screen and (max-width: 414px) {
  .App {
    width: 97%;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.header-logo-image-container {
  text-align: center;
  padding-bottom: 16px;
}

.header-logo-website-container {
  font-size: 1.15rem;
  margin-top: 14px;
}

.header-logo-text {
  color: #00b7ff;
}

.main-section-container {
  padding: 15px 25px;
}

.thank-you-container {
  padding-bottom: 16px;
}

.thank-you-header {
  margin: 0;
  padding-bottom: 5px;
  font-size: 1.4em;
  font-family: Arial;
  font-weight: bold;
}

.thank-you-paragraph {
  font-size: 1em;
  font-family: Arial;
  margin-top: 0;
  line-height: 20px;
}

/*Loading Spinner*/
.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 100px;
  height: 100px;
  margin: -75px 0 0 -75px;
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #3498db;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  display: none;
}

.loaderFixed {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 100px;
  height: 100px;
  margin: -75px 0 0 -75px;
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #3498db;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  display: none;
}

.review-site-container {
  margin-bottom: 15px;
}

.review-site-anchor {
  text-decoration: none;
  color: #fefefe;
}

.review-site-image-edmunds-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #418bd6;
  cursor: pointer;
}

.review-site-image-google-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(220, 78, 66);
  cursor: pointer;
}

.review-site-image-facebook-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(76, 112, 166);
  cursor: pointer;
}

.review-site-image-amazon-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #febd69;
  cursor: pointer;
}

.review-site-image-angieslist-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #7fbb00;
  cursor: pointer;
}

.review-site-image-bbb-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(0, 90, 119);
  cursor: pointer;
}

.review-site-image-cargurus-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #418bd6;
  cursor: pointer;
  border: 1px solid #8dbdfb;
}

.review-site-image-cappex-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #f99337;
  cursor: pointer;
}

.review-site-image-carscom-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(89, 33, 125);
  cursor: pointer;
}

.review-site-image-citysearch-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(88, 194, 248);
  cursor: pointer;
}

.review-site-image-dealerrater-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #e75300;
  cursor: pointer;
  border: 1px solid #2c3e83;
}

.review-site-image-glassdoor-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(12, 170, 65);
  cursor: pointer;
}

.review-site-image-healthgrades-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #003465;
  cursor: pointer;
  border: 1px solid #003466;
}

.review-site-image-indeedcom-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #2164f4;
  cursor: pointer;
  border: 1px solid #2063f2;
}

.review-site-image-merchantcircle-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(244, 90, 85);
  cursor: pointer;
}

.review-site-image-niche-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #59a44d;
  cursor: pointer;
}

.review-site-image-opentable-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #e51e2b;
  cursor: pointer;
}

.review-site-image-ratemds-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #529ea2;
  cursor: pointer;
  border: 1px solid rgb(82, 158, 162);
}

.review-site-image-surecritic-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(7, 135, 201);
  cursor: pointer;
}

.review-site-image-tripadvisor-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #479951;
  cursor: pointer;
}

.review-site-image-vitals-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(79, 73, 121);
  cursor: pointer;
}

.review-site-image-yelp-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(190, 47, 37);
  cursor: pointer;
}

.review-site-image-zomatocom-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: rgb(203, 32, 46);
  cursor: pointer;
}

.review-site-image-womendrivers-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #c63029;
  cursor: pointer;
}

.review-site-image-carfax-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #1976d2;
  cursor: pointer;
}

.review-site-image-yellowpages-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: #ffd400;
  cursor: pointer;
}

.review-site-image-default-container {
  height: 44px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 2px;
  background: inherit;
  cursor: pointer;
  border: none;
}

.review-site-image {
  padding: 7px;
  width: 45px;
  height: 45px;
  overflow: hidden;
}

.review-site-text {
  color: #ffffff;
  border-left: 1px solid rgba(255, 255, 255, 0.29);
  width: calc(100% - 41px);
  height: 44px;
  line-height: 44px;
  padding-left: 10px;
}

.footer-container {
  padding: 7px 25px;
  height: 3.5em;
  background: #332f2b;
}

.footer-social-icon {
  width: 38px;
  float: left;
  padding: 5px;
  filter: brightness(150%);
}

.terms-container {
  padding: 10px 30px 20px;
  font-size: 0.7em;
  margin-top: 0;
  margin-bottom: 0;
}

.terms-paragraph-optout-text {
  margin: 0;
  line-height: 15px;
  padding-top: 10px;
  padding-bottom: 5px;
}

.terms-paragraph {
  padding: 0;
  margin: 0;
  line-height: 25px;
}

.terms-das-logo {
  width: 140px;
}

.terms-privacy-policy {
  color: -webkit-link;
}

.terms-back-button {
  color: rgb(0, 183, 255);
  cursor: pointer;
}

.terms-and-conditions-link {
  text-decoration: underline;
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}

.terms-contact-info {
  position: relative;
}

.terms-contact-info-text {
  padding-bottom: 0px;
  margin: 0;
  line-height: 13px;
}

.terms-and-conditions-header {
  font-size: 1em;
  padding-bottom: 10px;
}

.terms-list-item-text {
  font-size: 0.8em;
  font-family: Arial;
}

.separator {
  height: 1px;
  background: #332f2b;
  margin: 0 30px;
}

.space {
  height: 15px;
}

.wrapper {
  padding: 20px;
}

.hidden {
  display: none;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EAEb,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EAEb,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EAEZ,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: left;\n  width: 610px;\n  background-color: white;\n  font-family: \"Arial Bold\", \"Arial\";\n  max-width: 680px;\n  margin: 0 auto;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@media screen and (max-width: 580px) {\n  .App {\n    width: 98%;\n  }\n}\n\n@media screen and (max-width: 414px) {\n  .App {\n    width: 97%;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.header-logo-image-container {\n  text-align: center;\n  padding-bottom: 16px;\n}\n\n.header-logo-website-container {\n  font-size: 1.15rem;\n  margin-top: 14px;\n}\n\n.header-logo-text {\n  color: #00b7ff;\n}\n\n.main-section-container {\n  padding: 15px 25px;\n}\n\n.thank-you-container {\n  padding-bottom: 16px;\n}\n\n.thank-you-header {\n  margin: 0;\n  padding-bottom: 5px;\n  font-size: 1.4em;\n  font-family: Arial;\n  font-weight: bold;\n}\n\n.thank-you-paragraph {\n  font-size: 1em;\n  font-family: Arial;\n  margin-top: 0;\n  line-height: 20px;\n}\n\n/*Loading Spinner*/\n.loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  width: 100px;\n  height: 100px;\n  margin: -75px 0 0 -75px;\n  border: 10px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 10px solid #3498db;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  display: none;\n}\n\n.loaderFixed {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  width: 100px;\n  height: 100px;\n  margin: -75px 0 0 -75px;\n  border: 10px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 10px solid #3498db;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n  display: none;\n}\n\n.review-site-container {\n  margin-bottom: 15px;\n}\n\n.review-site-anchor {\n  text-decoration: none;\n  color: #fefefe;\n}\n\n.review-site-image-edmunds-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #418bd6;\n  cursor: pointer;\n}\n\n.review-site-image-google-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(220, 78, 66);\n  cursor: pointer;\n}\n\n.review-site-image-facebook-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(76, 112, 166);\n  cursor: pointer;\n}\n\n.review-site-image-amazon-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #febd69;\n  cursor: pointer;\n}\n\n.review-site-image-angieslist-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #7fbb00;\n  cursor: pointer;\n}\n\n.review-site-image-bbb-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(0, 90, 119);\n  cursor: pointer;\n}\n\n.review-site-image-cargurus-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #418bd6;\n  cursor: pointer;\n  border: 1px solid #8dbdfb;\n}\n\n.review-site-image-cappex-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #f99337;\n  cursor: pointer;\n}\n\n.review-site-image-carscom-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(89, 33, 125);\n  cursor: pointer;\n}\n\n.review-site-image-citysearch-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(88, 194, 248);\n  cursor: pointer;\n}\n\n.review-site-image-dealerrater-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #e75300;\n  cursor: pointer;\n  border: 1px solid #2c3e83;\n}\n\n.review-site-image-glassdoor-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(12, 170, 65);\n  cursor: pointer;\n}\n\n.review-site-image-healthgrades-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #003465;\n  cursor: pointer;\n  border: 1px solid #003466;\n}\n\n.review-site-image-indeedcom-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #2164f4;\n  cursor: pointer;\n  border: 1px solid #2063f2;\n}\n\n.review-site-image-merchantcircle-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(244, 90, 85);\n  cursor: pointer;\n}\n\n.review-site-image-niche-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #59a44d;\n  cursor: pointer;\n}\n\n.review-site-image-opentable-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #e51e2b;\n  cursor: pointer;\n}\n\n.review-site-image-ratemds-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #529ea2;\n  cursor: pointer;\n  border: 1px solid rgb(82, 158, 162);\n}\n\n.review-site-image-surecritic-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(7, 135, 201);\n  cursor: pointer;\n}\n\n.review-site-image-tripadvisor-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #479951;\n  cursor: pointer;\n}\n\n.review-site-image-vitals-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(79, 73, 121);\n  cursor: pointer;\n}\n\n.review-site-image-yelp-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(190, 47, 37);\n  cursor: pointer;\n}\n\n.review-site-image-zomatocom-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: rgb(203, 32, 46);\n  cursor: pointer;\n}\n\n.review-site-image-womendrivers-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #c63029;\n  cursor: pointer;\n}\n\n.review-site-image-carfax-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #1976d2;\n  cursor: pointer;\n}\n\n.review-site-image-yellowpages-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #ffd400;\n  cursor: pointer;\n}\n\n.review-site-image-default-container {\n  height: 44px;\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 2px;\n  background: inherit;\n  cursor: pointer;\n  border: none;\n}\n\n.review-site-image {\n  padding: 7px;\n  width: 45px;\n  height: 45px;\n  overflow: hidden;\n}\n\n.review-site-text {\n  color: #ffffff;\n  border-left: 1px solid rgba(255, 255, 255, 0.29);\n  width: calc(100% - 41px);\n  height: 44px;\n  line-height: 44px;\n  padding-left: 10px;\n}\n\n.footer-container {\n  padding: 7px 25px;\n  height: 3.5em;\n  background: #332f2b;\n}\n\n.footer-social-icon {\n  width: 38px;\n  float: left;\n  padding: 5px;\n  -webkit-filter: brightness(150%);\n  filter: brightness(150%);\n}\n\n.terms-container {\n  padding: 10px 30px 20px;\n  font-size: 0.7em;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.terms-paragraph-optout-text {\n  margin: 0;\n  line-height: 15px;\n  padding-top: 10px;\n  padding-bottom: 5px;\n}\n\n.terms-paragraph {\n  padding: 0;\n  margin: 0;\n  line-height: 25px;\n}\n\n.terms-das-logo {\n  width: 140px;\n}\n\n.terms-privacy-policy {\n  color: -webkit-link;\n}\n\n.terms-back-button {\n  color: rgb(0, 183, 255);\n  cursor: pointer;\n}\n\n.terms-and-conditions-link {\n  text-decoration: underline;\n  color: -webkit-link;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.terms-contact-info {\n  position: relative;\n}\n\n.terms-contact-info-text {\n  padding-bottom: 0px;\n  margin: 0;\n  line-height: 13px;\n}\n\n.terms-and-conditions-header {\n  font-size: 1em;\n  padding-bottom: 10px;\n}\n\n.terms-list-item-text {\n  font-size: 0.8em;\n  font-family: Arial;\n}\n\n.separator {\n  height: 1px;\n  background: #332f2b;\n  margin: 0 30px;\n}\n\n.space {\n  height: 15px;\n}\n\n.wrapper {\n  padding: 20px;\n}\n\n.hidden {\n  display: none;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
